import { isNullish } from './helper'
import { stringToNumber } from './stringHelper'

export const sortBy = (key) => (a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0)

export const sumArrayProperty = (array, key) =>
  array.reduce((accumulator, object) => accumulator + stringToNumber(object[key]), 0)

export const sumArray = (array) => array.reduce((accumulator, item) => accumulator + item, 0)

export const getFirst = (array) => {
  if (!Array.isArray(array)) {
    return null
  }

  if (array.length === 0) {
    return null
  }

  return array[0]
}
export const getLast = (array) => {
  if (!Array.isArray(array)) {
    return
  }

  if (array.length === 0) {
    return
  }

  return array[array.length - 1]
}

export const arrayMin = (array) => {
  if (array.length === 0) {
    return undefined
  }

  return Math.min(...array)
}

export const arrayMax = (array) => {
  if (array.length === 0) {
    return undefined
  }

  return Math.max(...array)
}

export const createOptions = (data, labelKey, valueKey, withNilOption = false) => {
  const validOptions = []
  if (withNilOption) {
    validOptions.push({
      label: 'Nil',
      value: '',
    })
  }
  if (!data || !Array.isArray(data)) return validOptions
  data.forEach((item, itemIndex) => {
    const label = typeof labelKey === 'function' ? labelKey(item) : item[labelKey]
    if (isNullish(label) || (valueKey !== 'index' && !item[valueKey])) return

    validOptions.push({
      label: label,
      value: valueKey === 'index' ? itemIndex : item[valueKey],
    })
  })
  return validOptions
}

export const safeLength = (array) => {
  if (Array.isArray(array) && array.length > 0) {
    return array.length
  }
  return 0
}

export const findWithIndex = (array, predicate) => {
  if (!Array.isArray(array)) {
    return { index: -1, object: null }
  }

  const index = array.findIndex(predicate)
  if (index === -1) {
    return { index: -1, object: null }
  }

  return { object: array[index], index }
}

export const shareSomeElements = (arr1, arr2) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return false
  }
  const set = new Set(arr1)

  for (let elem of arr2) {
    if (set.has(elem)) {
      return true
    }
  }

  return false
}

export const filterArrayByUniqueKey = (array, key) => {
  const seen = new Set()
  return array.filter((item) => {
    const value = item[key]
    if (seen.has(value)) {
      return false
    } else {
      seen.add(value)
      return true
    }
  })
}
